var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconFilesObtainedPermissionLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconFilesObtainedPermission",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M960 0c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1489.355 0 960 430.645 0 960 0Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059Zm-167.463 643.25c8.007-8.051 19.014-12.934 30.371-12.099h273.303c11.09 0 21.017 3.892 29.734 12.1 8.65 8.207 13.055 17.932 13.055 29.623v268.056h-75.974V1372H855.974v-318.129H780V785.815c0-11.712 4.242-21.438 12.537-29.624ZM960.023 525c62.023 0 92.977 30.837 92.977 92.556 0 60.962-31 91.444-92.978 91.444C898.044 709 867 678.518 867 617.577v-.044C867 555.881 898 525 960.023 525Z",
        stroke: "#979797",
        fillRule: "evenodd"
      }))
    });
  }
}
IconFilesObtainedPermissionLine.glyphName = 'files-obtained-permission';
IconFilesObtainedPermissionLine.variant = 'Line';
IconFilesObtainedPermissionLine.displayName = 'IconFilesObtainedPermissionLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFilesObtainedPermissionLine.propTypes = {
  ...SVGIcon.propTypes
};
IconFilesObtainedPermissionLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFilesObtainedPermissionLine;
export { IconFilesObtainedPermissionLine };